import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { useMediaQuery } from 'react-responsive';

import { MEDIA_QUERY_TALL_SCREEN } from 'client/constants/mediaQueries';

import SrModalV2 from 'client/components/SrModalV2/SrModalV2';
import SrExternalLink from 'client/components/SrExternalLink';

const SrPartnerMarketingLinksModal = ({ links, onClose }) => {
  const isTallScreen = useMediaQuery({
    query: MEDIA_QUERY_TALL_SCREEN,
  });

  return (
    <SrModalV2
      closeOnBackgroundClick
      onClose={onClose}
      contentMaxWidth="400px"
      centerContent={isTallScreen}
      padding={isTallScreen ? '0' : '50px 0'}
    >
      <div className="SrPartnerMarketingLinksModal">
        <div className="linksModalTopSection">
          <span className="linksModalHeadline">Marketing Pages</span>
          {links.map(({ siteName, linkUrl }) =>
            linkUrl ? (
              <SrExternalLink
                link={linkUrl}
                key={siteName}
                className={classnames('linkRow', { active: !!linkUrl })}
              >
                <span className="linkSiteName">{siteName}</span>
                <div className="externalLink blue-link" />
              </SrExternalLink>
            ) : (
              <div key={siteName} className={classnames('comingSoonRow', { active: !!linkUrl })}>
                <span className="linkSiteName">{siteName}</span>
                <span className="inactiveLink">Coming soon</span>
              </div>
            ),
          )}
          <div className="linksModalFooter">
            <span>and many more...</span>
          </div>
        </div>
      </div>
      <div className="SrPartnerMarketingLinksModalOverlay" />
    </SrModalV2>
  );
};

SrPartnerMarketingLinksModal.propTypes = {
  links: PropTypes.arrayOf(
    PropTypes.shape({
      siteName: PropTypes.string.isRequired,
      linkUrl: PropTypes.string,
    }),
  ).isRequired,
  onClose: PropTypes.func.isRequired,
};

SrPartnerMarketingLinksModal.displayName = 'SrPartnerMarketingLinksModal';

export default SrPartnerMarketingLinksModal;
